@if(type !== AnnualSignGroup.CarbonCopy) {
  <div class="name-container">
    <div class="name">{{name}}</div>
    <div class="category">{{groupName}}</div>
  </div>
} @else {
  <div class="category">{{groupName}}</div>
}
